import { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { slugify } from '../utils/slugify';
import { getSubmissionStudioFilterClass } from '../utils/studios';
import submissions from '../data/submissionsAll';
import SubmissionTeaser from './submissionTeaser';

function shuffle(array) {
  const arr = [...array];
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

function SubmissionList({ activeFilter }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    setItems(shuffle(submissions));
  }, []);

  const filteredSubmissions = activeFilter 
    ? items.filter(item => {
        // Check if submission has the active filter class
        const tagClasses = item.Tags
          ? item.Tags.split(',').map(s => "t_" + slugify(s.trim()))
          : [];
        const demandClasses = item.Demands
          ? item.Demands.split("—, ").map(s => "d_" + slugify(s.replace("—", "").trim()))
          : [];
        const studioClass = item.Home_Studio
          ? [getSubmissionStudioFilterClass(item.Home_Studio)]
          : [];

        const allClasses = [...tagClasses, ...demandClasses, ...studioClass];
        return allClasses.includes(activeFilter);
      })
    : items;

  return (
    <div className="submission-list">
      {filteredSubmissions.map((item, index) => {
        const submissionId = item.Project_Title + (item.Timestamp || index);
        const delay = index * 0.02; // Stagger each submission by 20ms
        const submissionSlug = slugify(item.Project_Title);
        return (
          <div 
            key={submissionId}
            className="submission-wrapper rolling-down"
            style={{ animationDelay: `${delay}s` }}
          >
            <Link to={`/submission/${submissionSlug}`} style={{ textDecoration: 'none', color: 'inherit' }} onClick={() => window.scrollTo(0, 0)}>
              <SubmissionTeaser {...item} />
            </Link>
          </div>
        );
      })}
    
    
    
    </div>
  );
}

export default SubmissionList;